<template>
  <el-drawer :title="$t('Index.Components.UploadPopout.VisualSearch')" :visible.sync="visible" :size="isPC ? '700px' : '50%'" :direction="isPC?'rtl':'btt'" :with-header="false">
    <template>
      <div class="header p-r">
        <h3>{{ $t('Index.Components.UploadPopout.VisualSearch') }}</h3>
        <i class="iconfont icon-a-close-line1 close pointer" @click="close"></i>
      </div>
      <div class="body">
        <div class="f-b-c">
          <div class="title">{{ $t('Index.Components.UploadPopout.Tips1') }} </div>
          <div class="img-box f-b-c">
            <oss-img src="https://img.kakaclo.com/web-img/index/image_recognition.png" :width="240" :height="340" ></oss-img>
            <div style="">{{ $t('Index.Components.UploadPopout.Max5MBPerImage') }}</div>
          </div>
          <photograph @uploadSuccess="close" @beforeUpload="loading = true">
            <el-button type="primary" class="upload-btn" :loading="loading">{{ $t('Index.Components.UploadPopout.UploadImage') }}</el-button>
          </photograph>
        </div>
      </div>
    </template>
  </el-drawer>
</template>

<script>
import OssImg from '../../../components/OssImg.vue'
import Photograph from './Photograph.vue'
// import API from '@/api'
export default {
  components: { Photograph, OssImg },
  data() {
    return {
      visible: false,
      loading: false
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    show() {
      this.visible = true
    },
    close() {
      this.loading = false
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.header{
	width: 100%;
  padding: 25px;
	h3{
		font-weight: 500;
		font-size: 18px;
		line-height: 27px;
		color: #000000;
	}
	.close{
		position: absolute;
		top: 30px;
		right: 20px;
		font-size: 20px;
	}
}
.body{
  height: calc(100% - 78px);
  box-sizing: border-box;
  padding-top: 16vh;
  >div{
    flex-direction: column;
  }
  .title{
    font-size: 16px;
  }
  .img-box{
    margin-top: 20px;
    width: 270px;
    height: 400px;
    flex-direction: column;
    border: 1px solid #F4F6F9;
    padding: 14px 0;
    img{
      width: 240px;
      height: 340px;
    }
  }
  .upload-btn{
    margin: 28px 0;
    width: 300px;
    height: 50px;
  }
}
</style>
